import service from './request';
import { baseURL } from './baseUrl.js';
const parseFormDataParams = (data) => {
    const formData = new FormData();
    for (const name in data) {
        if (data.hasOwnProperty(name)) {
            if (data[name]) {
                formData.append(name, data[name]);
            }
        }
    }
    return formData;
};
const iApi = {
    // 顶岗实习计划列表
    getInternshipList: (query) => {
        return service({
            url: '/sxsqController/getSxjh',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 实习详细
    getInternshipDetail: (query) => {
        return service({
            url: '/sxsqController/getSxjhxq',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 实习中实习岗位
    getInternshipJob: (query) => {
        return service({
            url: '/sxsqController/sxgw',
            baseURL,
            method: 'get',
            params: query
        });
    },

    // 顶岗实习，统一实习申请详细数据
    getApplyDetail: (query) => {
        return service({
            url: '/sxsqController/getTysx',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 顶岗实习分散实习申请状态
    getApplyStatus: (query) => {
        return service({
            url: '/sxsqController/getSqzt',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 顶岗实习类型选择集合信息
    getPreInfoList: (query) => {
        return service({
            url: '/sxsqController/getInput',
            baseURL,
            method: 'get',
            params: query
        });
    },

    // 获取审批人列表
    getReviewer: (query) => {
        return service({
            url: '/selectReviewer',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 获取二级审批人列表
    getScoReviewer: (query) => {
        return service({
            url: '/examine/selectNextReviewer',
            baseURL,
            method: 'get',
            params: query
        });
    },

    // 分散实习申请
    setApplyInfo: (query) => {
        return service({
            url: '/sxsqController/fssxsq',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 获取省市
    getAreaList: (query) => {
        return service({
            url: '/sxsqController/getSfcs',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 获取申请状态
    getApplyStatus: (query) => {
        return service({
            url: query.url,
            baseURL,
            method: 'get',
            params: query.data
        });
    },
    // 重新申请获取数据
    getReapplyInfo: (query) => {
        return service({
            url: '/sxsqController/getSqnr',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 上传图片附件
    uploadImg: (query) => {
        return service({
            url: '/sxsqController/upload',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 获取免实习申请预置数据
    getPreInfo: (query) => {
        return service({
            url: '/MsxsqController/getXsxx',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 免实习申请
    setFreeApplyInfo: (query) => {
        return service({
            url: '/MsxsqController/msxsq',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 重新免实习申请
    getRefreeApplyInfo: (query) => {
        return service({
            url: '/MsxsqController/cxsq',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取当前考勤计划
    getAttendanceInfo: (query) => {
        return service({
            url: '/student/getSxkqRw',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 计算考勤距离是否在范围内
    getAttendancePosition: (query) => {
        return service({
            url: '/student/isKqdd',
            baseURL,
            method: 'get',
            params: query
        });
    },

    // 打卡保存
    setSignInfo: (query) => {
        return service({
            url: '/student/kqdkSave',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 获取考勤打卡时间
    getSignTimeList: (query) => {
        return service({
            url: 'student/getDksj',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取打卡记录
    getAttendanceList: (query) => {
        return service({
            url: '/student/getKqdk',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 补卡申请
    setReSignInfo: (query) => {
        return service({
            url: '/student/bksq',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },

    // 月统计
    getAttendanceTotal: (query) => {
        return service({
            url: '/student/getDktj',
            baseURL,
            method: 'get',
            params: query
        });
    },

    // 获取请假列表
    getAskLevelList: (query) => {
        return service({
            url: '/student/getQjsq',
            baseURL,
            method: 'get',
            params: query
        });
    },

    // 免签申请
    postFreeSign: (query) => {
        return service({
            url: '/student/mqsq',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 获取免签列表
    getFreeSignList: (query) => {
        return service({
            url: '/student/getMqsq',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 请假申请
    postAskLevel: (query) => {
        return service({
            url: '/student/qjsq',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 获取请假申请列表
    getAskLevelList: (query) => {
        return service({
            url: '/student/getQjsq',
            baseURL,
            method: 'get',
            params: query
        });
    },
    // 查询实习项目列表
    getSxxmList: (query) => {
        return service({
            url: '/sxxmController/sxxm',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询实习信息
    getSxxm: (query) => {
        return service({
            url: '/sxxmController/sxxx',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 新增实习项目
    addSxxm: (query, data) => {
        return service({
            url: '/sxxmController/sxxmsq',
            method: 'POST',
            baseURL,
            params: query,
            data: parseFormDataParams(data)
        });
    },
    // 查询实习项目详情
    getSxxmDetail: (query) => {
        return service({
            url: '/sxxmController/sxxmxq',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询实习项目详情
    getReSxxmDetail: (query) => {
        return service({
            url: '/sxxmController/wtgxm',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 查询实习变更列表
    getChangeList: (query) => {
        return service({
            url: '/sxbgsqController/getSxbglb',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 统一实习变更获取基地列表
    getJdList: (query) => {
        return service({
            url: '/sxbgsqController/getSxjd',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取基地岗位列表和详细
    getGwListDetail: (query) => {
        return service({
            url: '/sxbgsqController/getSxgw',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取岗位详细
    getGwDetail: (query) => {
        return service({
            url: '/sxbgsqController/getSxgwxq',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 新建统一实习变更
    postUniChangeData: (query) => {
        return service({
            url: '/sxbgsqController/tysxbg',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 分散实习企业搜索
    getQyList: (query) => {
        return service({
            url: '/sxbgsqController/getSxqymc',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取企业详细
    getQyDetail: (query) => {
        return service({
            url: '/sxbgsqController/getSxqyxq',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 新建分散实习变更
    postDisperseChangeData: (query) => {
        return service({
            url: '/sxbgsqController/fssxbg',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 获取统一实习变更数据
    getTyDetail: (query) => {
        return service({
            url: '/sxbgsqController/getBgtysx',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取统一实习变更重新申请数据
    getReTyDetail: (query) => {
        return service({
            url: '/sxbgsqController/tysxbgcxsq',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 获取分散实习变更数据
    getFsDetail: (query) => {
        return service({
            url: '/sxbgsqController/getBgfssx',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取分散实习重新变更数据
    getReFsDetail: (query) => {
        return service({
            url: '/sxbgsqController/fssxbgcxsq',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 实习日期限制时间
    getDailyTime: (query) => {
        return service({
            url: '/student/findDelayValueBySxjhid',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 新增实习日志
    postDailyData: (query) => {
        return service({
            url: '/student/addSxrz',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 查询实习日志月历
    getDailyList: (query) => {
        return service({
            url: '/student/querySxrzHistory',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询实习日志详细
    getDailyDetail: (query) => {
        return service({
            url: '/student/getSxrzDetail',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 实习周报限制时间
    getWeeklyTime: (query) => {
        return service({
            url: '/sxzbController/findDelayValueBySxjhidZb',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 新增实习周报
    postWeeklyData: (query) => {
        return service({
            url: '/sxzbController/addSxzb',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 查询实习周报记录
    getWeeklyList: (query) => {
        return service({
            url: '/sxzbController/querySxzbHistory',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询实习周报详细
    getWeeklyDetail: (query) => {
        return service({
            url: '/sxzbController/getSxzbDetail',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 实习月报限制时间
    getMonthlyTime: (query) => {
        return service({
            url: '/sxybController/toFind',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 新增实习月报
    postMonthlyData: (query) => {
        return service({
            url: '/sxybController/toSxybAdd',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 查询实习月报记录
    getMonthlyList: (query) => {
        return service({
            url: '/sxybController/toSxybNyjl',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询实习月报详细
    getMonthlyDetail: (query) => {
        return service({
            url: '/sxybController/toSxybDetails',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 新增实习总结
    postSummaryData: (query) => {
        return service({
            url: '/student/sxzjadd',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    // 实习总结列表
    getSummaryList: (query) => {
        return service({
            url: '/student/getXssxzjList',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 实习总结详细
    getSummaryDetail: (query) => {
        return service({
            url: '/student/getXssxzjDetail',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 结束实习提交
    postDoneData: (query) => {
        return service({
            url: '/xsDgsx/saveSxJs',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },
    getDoneImg: (query) => {
        return service({
            url: '/xsDgsx/getSxJs',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取实习成绩
    getAchieveData: (query) => {
        return service({
            url: '/xsDgsx/getSxCj',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 教师端
    // 实习计划
    getInternShipList: (query) => {
        return service({
            url: '/jsdsxzd/getJsdsxjh',
            method: 'get',
            baseURL,
            params: query
        });
    },

    getSomeThingWillDo: (query) => {
        return service({
            url: '/jsdsxzd/getSomeThingWillDoList',
            method: 'post',
            baseURL,
            params: query
        });
    },

    // 我的实习生列表
    getMyStudentList: (query) => {
        return service({
            url: '/teacher/getMysxs',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 审批列表通用请求
    getApprovalList: (query) => {
        return service({
            url: query.url,
            baseURL,
            method: 'get',
            params: query.data
        });
    },
    // 通过拒绝用接口
    rejectOrAgree: (query) => {
        return service({
            url: query.url,
            baseURL,
            method: 'get',
            params: query.data
        });
    },
    // 实习总结列表
    getSummrayList: (query) => {
        return service({
            url: '/teacher/getXssxzjLIst',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 实习总结详细
    getSummrayDetail: (query) => {
        return service({
            url: '/teacher/getXssxzjDetail',
            method: 'get',
            baseURL,
            params: query
        });
    },
    postSummary: (query) => {
        return service({
            url: '/teacher/sxzjapy',
            method: 'post',
            baseURL,
            params: query
        });
    },
    // 考勤打卡统计
    getAttendance: (query) => {
        return service({
            url: '/teacher/getXssxkqqk',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 考勤打卡列表
    getAttendanceStu: (query) => {
        return service({
            url: '/teacher/getXssxkqList',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 考勤打卡学生日历
    getAttendanceStuDetail: (query) => {
        return service({
            url: '/teacher/getXssxkqDetail',
            method: 'get',
            baseURL,
            params: query
        });
    },
    //
    getAttendanceStuTotal: (query) => {
        return service({
            url: '/teacher/getXssxkqTjxq',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 指导学生列表
    getGuideList: (query) => {
        return service({
            url: '/jsdsxzd/getSxzd',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 知道学生
    getGuideStudent: (query) => {
        return service({
            url: '/jsdsxzd/getSxzdlb',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 指导详细
    getGuideStudentDetail: (query) => {
        return service({
            url: '/jsdsxzd/getSxzdxq',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 获取本计划所有学生
    getStudentList: (query) => {
        return service({
            url: '/jsdsxzd/getSxzdxs',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 新增指导
    postGuideData: (query) => {
        return service({
            url: '/jsdsxzd/tjsxzd',
            method: 'post',
            baseURL,
            data: parseFormDataParams(query)
        });
    },

    // 查询学生月报
    getXsybList: (query) => {
        return service({
            url: '/sxybController/toSxybXsybJsd',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询学生月报
    getXsybIdList: (query) => {
        return service({
            url: '/sxybController/toSxybXSNyjlJsd',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询学生月报详情
    getXsybIdDetail: (query) => {
        return service({
            url: '/sxybController/toSxybDetailsJsd',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 评阅学生月报
    postXsybSavePyJsd: (query) => {
        return service({
            url: '/sxybController/toSavePyJsd',
            method: 'post',
            baseURL,
            params: query
        });
    },
    // 查询学生日志列表
    getSxrzByDate: (query) => {
        return service({
            url: '/teacher/queryAllSxrzByDate',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询学生日志详情
    getSxrzDetail: (query) => {
        return service({
            url: '/teacher/getSxrzDetail',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 提交学生日志评阅
    getSaveSxrzPy: (query) => {
        return service({
            url: '/teacher/saveSxrzPy',
            method: 'get',
            baseURL,
            params: query
        });
    },

    // 查询学生周报列表
    getXszbList: (query) => {
        return service({
            url: '/jsDgsx/getXsZbList',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询学生周报列表
    getXsZbMzJl: (query) => {
        return service({
            url: '/jsDgsx/getXsZbMzJl',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 查询学生周报详情
    getXsZbDeatil: (query) => {
        return service({
            url: '/jsDgsx/getXsZb',
            method: 'get',
            baseURL,
            params: query
        });
    },
    // 提交周报评阅
    saveZdJsPy: (query) => {
        return service({
            url: '/jsDgsx/saveZdJsPy',
            method: 'post',
            baseURL,
            params: query
        });
    },
    //成都学院  实习接口
    getXsXx: (query) => {
        return service({
            url: '/xsCdty/getXsXx',
            method: 'get',
            baseURL,
            params: query
        });
    },
    //成都学院 实习打卡 提交按钮
    getSaveXsSxDk: (query) => {
        return service({
            url: '/xsCdty/saveXsSxDk',
            method: 'post',
            baseURL,
            params: query
        });
    },
    getSxrzTime: (query) => {
        return service({
            url: '/jsDgsx/getSxrzTime',
            method: 'post',
            baseURL,
            params: query
        });
    },
     // 实习总结列表
     downloadDgsx: (query) => {
        return service({
            url: '/student/downloadDgsx',
            method: 'post',
            baseURL,
            responseType: 'blob',
            params: query,
        });
    },
    getSxGwxx: () => {
        return service({
            url: '/student/getSxGwxx',
            method: 'post',
            baseURL
        })
    },
    fjscSave: (query) => {
        return service({
          url: '/student/fjscSave',
          method: 'post',
          baseURL,
          data: parseFormDataParams(query),
        })
    },
    // 上传协议列表
    getDsfxyList: (query) => {
        return service({
            url: '/student/getDsfxyList',
            method: 'get',
            baseURL,
            params: query
        });
    },
     // 判断是否符合上传条件
     getIssctj: (query) => {
        return service({
            url: '/student/getIssctj',
            method: 'get',
            baseURL,
            params: query
        });
    },
    getDoneSxjdb: (query) => {
        return service({
            url: '/xsDgsx/getDoneSxjdb',
            method: 'post',
            baseURL,
            responseType: 'blob',
            params: query,
        });
    },
    fileDownload: (query) => {
        return service({
            url: '/upload/fileDownload',
            method: 'post',
            baseURL,
            responseType: 'blob',
            params: query,
        });
    },
    checkDoneSjscdc: (query) => {
        return service({
            url: '/xsDgsx/getDoneSjscdc',
            method: 'post',
            baseURL,
            params: query,
        });
    },
    getDoneSjscdc: (query) => {
        return service({
            url: '/xsDgsx/getDoneSjscdc',
            method: 'post',
            baseURL,
            responseType: 'blob',
            params: query,
        });
    },
    bxscDetail: (query) => {
        return service({
        url: "/xsDgsx/bxscDetail",
        method: "post",
        baseURL,
        params: query
        });
    },
    bxsc: (query) => {
        return service({
        url: "/xsDgsx/bxsc",
        method: "post",
        baseURL,
        params: query
        });
    },
    bxfindXyOrJzzqsshListsc: (query) => {
        return service({
            url: "/jsDgsx/findXyOrJzzqsshList",
            method: "post",
            baseURL,
            params: query
        });
    },
    findXyOrJzzqsshDetail: (query) => {
        return service({
            url: "/jsDgsx/findXyOrJzzqsshDetail",
            method: "post",
            baseURL,
            params: query
        });
    },
    findXyOrJzzqsshSh: (query) => {
        return service({
            url: "/jsDgsx/findXyOrJzzqsshSh",
            method: "post",
            baseURL,
            params: query
        });
    },
    loadfindXyOrJzzqsshFileYlfile: (query) => {
        return service({
            url: '/jsDgsx/findXyOrJzzqsshFileYl',
            method: 'post',
            baseURL,
            params: query,
        })
    },
};
export default iApi;



// WEBPACK FOOTER //
// ./src/utils/internship.js